"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_2 = require("@osmosys/react");
const ButtonContainer_1 = require("../ButtonContainer");
exports.EmailCanvasBlockClearContentButton = ({ isClearable, clearBlock, isHighlighted, }) => {
    // const { clearBlock } = useEmailCanvasBlockDetailChangeContext();
    // const {
    //   meta: { isClearable },
    // } = useEmailCanvasBlockDetailContext();
    if (!isClearable) {
        return null;
    }
    return (react_1.default.createElement(ButtonContainer_1.ButtonContainer, null,
        react_1.default.createElement(Inner, { isClearable: isClearable, clearBlock: clearBlock, isHighlighted: isHighlighted })));
};
const Inner = ({ clearBlock, isClearable, isHighlighted }) => {
    if (isHighlighted) {
        return (react_1.default.createElement(react_2.OsmosysButton, { tooltip: "Clear content", size: "sm", disabled: !isClearable, osysIcon: "erase", osysStyle: "default", iconStyle: "solid", className: "ml-1", color: "primary", outline: true, osysName: "EmailCanvasBlockClearContentButton", onClick: () => {
                if (!isClearable) {
                    return;
                }
                clearBlock();
            } }, "Clear"));
    }
    return (react_1.default.createElement(react_2.OsmosysButtonBlockToolbar, { tooltip: "Clear content", osysIcon: "erase", 
        // confirm={block.type === 'group'}
        disabled: !isClearable, osysName: "EmailCanvasBlockClearContentButton", onClick: () => {
            if (!isClearable) {
                return;
            }
            clearBlock();
        } }));
};
//# sourceMappingURL=ClearContentButton.js.map